/**
 * Fetch a file from the API with the signed-in session and hand it to the
 * browser as a download. For PDFs and workbooks the server renders; a plain
 * link cannot carry the bearer token.
 */
import { supabase } from './supabase.js';
import { baseUrl } from './api.js';

export async function downloadAuthed(path, filename) {
  const { data } = await supabase.auth.getSession();
  const res = await fetch(`${baseUrl}${path}`, {
    headers: { Authorization: `Bearer ${data?.session?.access_token ?? ''}` },
  });
  if (!res.ok) throw new Error(`Could not build the file (${res.status}).`);
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 10_000);
}

export default downloadAuthed;
